/**
 * Automatisch generiert von `npm run version:sync` - NICHT manuell bearbeiten.
 *
 * Quelle der Wahrheit ist das Feld "version" der Root-package.json.
 * Paket: @kern/feedback-widget
 */

/** Vollstaendige SemVer-2.0.0-Version dieses Pakets. */
export const VERSION = '2.11.0';

/** Einzelbestandteile der Version fuer Kompatibilitaetspruefungen. */
export const VERSION_INFO = {
  major: 2,
  minor: 11,
  patch: 0,
  prerelease: null,
} as const;
